import './App.css';
import Box from '@mui/material/Box';

const NoPage = () => {
  return (
    <Box sx={{ maxWidth: 480, mx: 'auto', mt: 6, p: 3, textAlign: 'center', color: 'var(--text)' }}>
      <Box sx={{ fontSize: 48, fontWeight: 800, color: 'var(--primary)', lineHeight: 1 }}>404</Box>
      <Box sx={{ fontSize: 14, color: 'var(--muted)', mt: 1.5 }}>
        Well how did you get here then? Probably best to go back{' '}
        <Box component="a" href="/" sx={{ color: 'var(--primary)', fontWeight: 600 }}>home</Box>{' '}
        and try again.
      </Box>
    </Box>
  );
};

export default NoPage;